export default {
    logo: require('../../assets/images/logo/logo-y.png'),
    product: {
        hasVariety: true,
        hasColor: false,
        hasSizeChart: false
    },
    sizeChart: {
        changeColumn: false, // کم و زیاد کردن ستون ها
        hasType: true // آیا سایز چارت تایپ دارد یا نه
    }
}